import { render } from "./BankDetail.vue?vue&type=template&id=33421cb0&scoped=true"
import script from "./BankDetail.vue?vue&type=script&lang=js"
export * from "./BankDetail.vue?vue&type=script&lang=js"

import "./BankDetail.vue?vue&type=style&index=0&id=33421cb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33421cb0"]])

export default __exports__